export const eventDefaultColumns = [
  'EventID',
  'OriginalEventType',
  'EventType',
  'EventTypeDescription',
  'EventSubType',
  'Status',
  'CaseID',
  'FullAddress',
  'StreetName',
  'AgencyID',
  'Created',
  'CreatedBy',
  'Updated',
  'UpdatedBy',
  'IsDeleted',
  'DeletedBy',
  'DeletedIP',
  { field: 'Received', headerName: 'Received', format: 'date', width: 150 },
  { field: 'Queued', headerName: 'Queued', format: 'date', width: 150 },
  { field: 'Dispatched', headerName: 'Dispatched', format: 'date', width: 150 },
  { field: 'Enroute', headerName: 'Enroute', format: 'date', width: 150 },
  { field: 'Arrived', headerName: 'Arrived', format: 'date', width: 150 },
  { field: 'Completed', headerName: 'Completed', format: 'date', width: 150 },
];

export const eventNoDeletedColumns = [
  'EventID',
  'OriginalEventType',
  'EventType',
  'EventTypeDescription',
  'EventSubType',
  'Status',
  'CaseID',
  'FullAddress',
  'StreetName',
  'AgencyID',
  'Created',
  'CreatedBy',
  'Updated',
  'UpdatedBy',
  { field: 'Received', headerName: 'Received', format: 'date', width: 150 },
  { field: 'Queued', headerName: 'Queued', format: 'date', width: 150 },
  { field: 'Dispatched', headerName: 'Dispatched', format: 'date', width: 150 },
  { field: 'Enroute', headerName: 'Enroute', format: 'date', width: 150 },
  { field: 'Arrived', headerName: 'Arrived', format: 'date', width: 150 },
  { field: 'Completed', headerName: 'Completed', format: 'date', width: 150 },
];

export const advancedEventDefaultColumns = [
  'EventID',
  'OriginalEventType',
  'EventType',
  'EventTypeDescription',
  'EventSubType',
  'Status',
  'CaseID',
  'FullAddress',
  'StreetName',
  'AgencyID',
  'PartyName',
  'PartyRelationship',
  'Disposition',
  'Zone',
  'Created',
  'CreatedBy',
  'Updated',
  'UpdatedBy',
  'IsDeleted',
  'DeletedBy',
  'DeletedIP',
  { field: 'Received', headerName: 'Received', format: 'date', width: 150 },
  { field: 'Queued', headerName: 'Queued', format: 'date', width: 150 },
  { field: 'Dispatched', headerName: 'Dispatched', format: 'date', width: 150 },
  { field: 'Enroute', headerName: 'Enroute', format: 'date', width: 150 },
  { field: 'Arrived', headerName: 'Arrived', format: 'date', width: 150 },
  { field: 'Completed', headerName: 'Completed', format: 'date', width: 150 },
];

export const advancedEventsNoDeletedColumns = [
  'EventID',
  'OriginalEventType',
  // { field: 'EventType', headerName: 'Event Type' },
  // { field: 'EventSubType', headerName: 'Event Sub Type' },
  'EventType',
  'EventTypeDescription',
  'EventSubType',
  'Status',
  'CaseID',
  'FullAddress',
  'StreetName',
  'AgencyID',
  'PartyName',
  'PartyRelationship',
  'Disposition',
  'Zone',
  'Created',
  'CreatedBy',
  'Updated',
  'UpdatedBy',
  { field: 'Received', headerName: 'Received', format: 'date', width: 150 },
  { field: 'Queued', headerName: 'Queued', format: 'date', width: 150 },
  { field: 'Dispatched', headerName: 'Dispatched', format: 'date', width: 150 },
  { field: 'Enroute', headerName: 'Enroute', format: 'date', width: 150 },
  { field: 'Arrived', headerName: 'Arrived', format: 'date', width: 150 },
  { field: 'Completed', headerName: 'Completed', format: 'date', width: 150 },
];
